export default {
  email_confirm: {
    header: {
      title: 'Konfirmasi alamat email selesai',
    },
    completed: {
      section_one: 'Kami telah mengirimkan ID login dan kata sandi Anda ke alamat email yang Anda masukkan.',
      section_two: 'Periksa email Anda dan ikuti petunjuk dalam email untuk login. ',
      section_three: 'Jika Anda belum menerimanya setelah 30 menit, silakan beri tahu kami di ',
      section_four: 'Orang yang bertanggung jawab akan menghubungi Anda lagi.',
    },
    expired: {
      section_one: 'URL yang diberikan sudah kedaluwarsa',
      section_two: 'Jika Anda ingin menggunakan layanan ini, silakan hubungi ',
      section_three: 'Orang yang bertanggung jawab akan menghubungi Anda.',
    },
    btn: {
      service_top: 'Atas',
      login: 'Login',
      register: 'Daftar',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
